/**
 * Given a value and two ranges, scale the value (which is somewhere in the `r` range)
 * so that it's scaled proportional to the `t` range
 *
 * For example,
 *   `let value = 100`,
 *   `let r = [20, 320]`,
 *   `let t = [10, 40]`
 *
 * `value` would be scaled down to 18, so it's in between 10 - 40
 *
 * @param {Number} value The value to scale
 * @param {Array} r The range value is in
 * @param {Array} t The range to scale to
 * @return {Number} - The scaled number
 */
function scale(value, r, t) {
  // Handle cases where r ranges over a single number
  if (r[0] === r[1]) {
    return t[0];
  }

  if (value < r[0]) {
    return t[0];
  } else if (value > r[1]) {
    return t[1];
  }

  const rmin = r[0];
  const rmax = r[1];

  const tmin = t[0];
  const tmax = t[1];

  const pct = (value - rmin) / (rmax - rmin);
  const range = tmax - tmin;

  return pct * range + tmin;
}

export default scale;
